export const isInitiated = (s) => {
    return !!Object.keys(s.countries).length
}

export const countries = (s) => {
    return s.countries
}

export const states = s => (country) => {
    return (typeof s.states[country] !== 'undefined') ?s.states[country] :{}
}

export const ratingSystems = (s) => {
    return s.ratingSystems
}

export const ownerTypes = (s) => {
    return s.ownerTypes
}

export const anticipatedTypes = s => (program) => {
    if(program === 'campus')
        return s.peerCampusUseTypes
    
    else if(program === 'utility')
        return s.peerUtilityUseTypes
    
    else if(program === 'transit')
        return s.peerTransitUseTypes
}

export const teamRoles = (s) => {
    return s.teamRoles
}

export const notifyPending = (s) => {
    return s.notifyPending
}

export const postalCodeCache = s => (input) => {
    let key = input.country+':'+input.state+':'+input.postalCode
    return s.postalCodes[key]
}

export default {
    isInitiated,
    countries, states,
    ratingSystems, ownerTypes, anticipatedTypes, teamRoles,
    notifyPending,
    postalCodeCache
}
